// src/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCYqBarndX7iaY36f3jqz0Xp9oO10PefVs",
  authDomain: "document-scanner-4701a.firebaseapp.com",
  projectId: "document-scanner-4701a",
  storageBucket: "document-scanner-4701a.firebasestorage.app",
  messagingSenderId: "812042825646",
  appId: "1:812042825646:web:c74e6fc4b1650c3eece23f",
  measurementId: "G-4NQGDBVK16"
};

const app = initializeApp(firebaseConfig);

// Auth & Firestore
export const auth = getAuth(app);
export const db = getFirestore(app);
